/* MX Cart Drawer — opens from the cart icon and after any add to cart; renders from /cart.js */
(function () {
  var drawer = document.getElementById('MxCart');
  if (!drawer || drawer.dataset.ready) return;
  drawer.dataset.ready = '1';

  var root = (drawer.dataset.root || '/').replace(/\/$/, '');
  var cartUrl = drawer.dataset.cartUrl || '/cart';
  var moneyFormat = drawer.dataset.moneyFormat || '{{amount}}';
  var freeThreshold = parseInt(drawer.dataset.freeThreshold, 10) || 0;
  var itemsEl = drawer.querySelector('[data-mxcart-items]');
  var emptyEl = drawer.querySelector('[data-mxcart-empty]');
  var footEl = drawer.querySelector('[data-mxcart-foot]');
  var subtotalEl = drawer.querySelector('[data-mxcart-subtotal]');
  var countEl = drawer.querySelector('[data-mxcart-count]');
  var freeEl = drawer.querySelector('[data-mxcart-free]');
  var lastTrigger;

  /* ---------- money ---------- */
  function money(cents) {
    var value = cents / 100;
    function fmt(n, dec, thousands, decimal) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- render ---------- */
  function render(cart) {
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    subtotalEl.textContent = money(cart.total_price);
    document.querySelectorAll('[data-mx-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });

    var empty = cart.item_count === 0;
    emptyEl.hidden = !empty;
    footEl.hidden = empty;

    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var variant = (item.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); })
        .join(' / ');
      var was = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
      return '' +
        '<li class="mxcart__item" data-line="' + line + '" data-qty="' + item.quantity + '">' +
          '<a class="mxcart__img" href="' + esc(item.url) + '">' +
            (item.image ? '<img src="' + esc(sized(item.image, 300)) + '" alt="' + esc(item.product_title) + '" width="300" height="375" decoding="async">' : '') +
          '</a>' +
          '<div class="mxcart__info">' +
            '<div class="mxcart__top">' +
              '<a class="mxcart__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              '<span class="mxcart__price">' + was + money(item.final_line_price) + '</span>' +
            '</div>' +
            (variant ? '<div class="mxcart__variant">' + variant + '</div>' : '') +
            '<div class="mxcart__actions">' +
              '<div class="mxcart__qty">' +
                '<button type="button" data-mxcart-qty="-1" aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 12h12"/></svg></button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-mxcart-qty="1" aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg></button>' +
              '</div>' +
              '<button type="button" class="mxcart__remove" data-mxcart-remove>Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    }).join('');

    if (freeEl && freeThreshold > 0) {
      var left = freeThreshold - cart.total_price;
      var text = left > 0
        ? drawer.dataset.freeText.replace('[amount]', '<strong>' + money(left) + '</strong>')
        : esc(drawer.dataset.freeDone);
      freeEl.querySelector('[data-mxcart-free-text]').innerHTML = text;
      freeEl.querySelector('[data-mxcart-free-bar]').style.width = Math.min(100, cart.total_price / freeThreshold * 100) + '%';
      freeEl.hidden = empty;
    }
  }

  var lastJson = '';
  function refresh() {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* only re-draw when something changed (no flicker) */
        var json = JSON.stringify([cart.token, cart.item_count, cart.total_price, cart.items.map(function (i) { return i.key + ':' + i.quantity; })]);
        if (json !== lastJson) { lastJson = json; render(cart); }
        return cart;
      });
  }

  /* build the drawer in the background right after the page loads, so the first open is instant */
  function warmUp() { refresh().catch(function () {}); }
  if (document.readyState === 'complete') setTimeout(warmUp, 0);
  else window.addEventListener('load', function () { setTimeout(warmUp, 0); });

  /* ---------- open / close ---------- */
  function open(trigger) {
    lastTrigger = trigger || document.activeElement;
    refresh();
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mxcart-lock');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    var x = drawer.querySelector('.mxcart__close');
    if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 50);
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mxcart-lock');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
  }
  window.MxCart = { open: open, close: close, refresh: refresh };

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-mxcart-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* header cart icon opens the drawer */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.mx-icon-btn--cart');
    if (!link || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    open(link);
  });

  /* ---------- change quantity / remove ---------- */
  function change(li, quantity) {
    li.classList.add('is-busy');
    fetch(root + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(li.dataset.line, 10), quantity: quantity })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not update'); return d; }); })
      .then(function (cart) {
        render(cart);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mx-cart-drawer', cartData: cart });
        }
      })
      .catch(function (err) {
        li.classList.remove('is-busy');
        var msg = li.querySelector('.mxcart__item-error') || document.createElement('p');
        msg.className = 'mxcart__item-error';
        msg.textContent = err.message;
        li.querySelector('.mxcart__info').appendChild(msg);
      });
  }

  itemsEl.addEventListener('click', function (e) {
    var li = e.target.closest('.mxcart__item');
    if (!li) return;
    var step = e.target.closest('[data-mxcart-qty]');
    if (step) {
      change(li, Math.max(0, parseInt(li.dataset.qty, 10) + parseInt(step.dataset.mxcartQty, 10)));
      return;
    }
    if (e.target.closest('[data-mxcart-remove]')) change(li, 0);
  });

  /* ---------- open after anything is added to the cart ---------- */
  var openTimer;
  function addedToCart() {
    clearTimeout(openTimer);
    openTimer = setTimeout(function () {
      if (drawer.classList.contains('is-open')) refresh(); else open();
    }, 80);
  }
  document.addEventListener('cart:updated', addedToCart);
  function subscribeDawn() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'mx-cart-drawer') return;
        if (evt && evt.source === 'mx-product-card') return; /* handled by cart:updated */
        addedToCart();
      });
      return true;
    }
    return false;
  }
  if (!subscribeDawn()) document.addEventListener('DOMContentLoaded', subscribeDawn);

  /* the small "Added to cart" toast from the product card is not needed with the drawer */
  document.documentElement.classList.add('has-mxcart');
})();
